import React from 'react';
import { Stack } from '@chakra-ui/react';
const styles = {
    flexDirection: {
        base: 'row',
        sm: 'column',
        md: 'column',
        xl: 'row',
    },
};
const ResponsiveStack = ({ children, ...rest }) => (React.createElement(Stack, { sx: styles, gap: 2, alignItems: "start", ...rest }, children));
export default ResponsiveStack;
